import { render, staticRenderFns } from "./PlotsGHG.vue?vue&type=template&id=2474502e"
import script from "./PlotsGHG.vue?vue&type=script&lang=js"
export * from "./PlotsGHG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports